import React from 'react';

export default function SkillSertifikasi() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Skill & Sertifikasi</h1>
      <p className="text-gray-500">Halaman Skill & Sertifikasi</p>
    </div>
  );
}
